
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

@Component({
})
export default class extends Vue {
  get industryIdx() {
    return UserModule.industry;
  }

  private handleClickMenu(routeName: any) {
    this.$router.push({ name: routeName }).catch((err) => {
      if (err.name !== 'NavigationDuplicated') {
        // Revert the menu active item if navigation was cancelled
        const menu: any = this.$refs.sidebarMenu;
        if (menu) {
          menu.activeIndex = this.$route.name;
        }
      }
    });
  }
}
